import {
  REQUEST_STATUS,
  SET_LOADING_STATUS,
  SET_OPEN,
  CLEAR_STATUS,
  SET_SAVING_STATUS,
  SET_SAVING_OPEN,
  HIDE_MENU_ITEMS,
  SHOW_MENU_ITEMS,
  SHOW_ERROR_MESSAGE,
  HIDE_ERROR_MESSAGE,
} from '../../constants/global';

const initialState = {
  status: {},
  loading: false,
  open: false,
  saving: false,
  savingOpen: false,
  showingMenuItems: window.innerWidth > 768,
  showError: false,
  errorMessage: '',
  refresh: false,
  blacklistAlert: { show: false, customer: null },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_STATUS:
      return {
        ...state,
        status: action.status,
      };
    case SET_LOADING_STATUS:
      return {
        ...state,
        loading: action.loading,
      };
    case SET_OPEN:
      return {
        ...state,
        open: action.open,
      };
    case CLEAR_STATUS:
      return {
        ...state,
        status: {},
      };
    case SET_SAVING_STATUS:
      return {
        ...state,
        saving: action.saving,
      };
    case SET_SAVING_OPEN:
      return {
        ...state,
        savingOpen: action.savingOpen,
      };
    case HIDE_MENU_ITEMS:
      return {
        ...state,
        showingMenuItems: false,
      };
    case SHOW_MENU_ITEMS:
      return {
        ...state,
        showingMenuItems: true,
      };
    case SHOW_ERROR_MESSAGE:
      return {
        ...state,
        showError: true,
        errorMessage: action.message,
      };
    case HIDE_ERROR_MESSAGE:
      return {
        ...state,
        showError: false,
        errorMessage: '',
      };
    case 'TRIGGER_REFRESH':
      return { ...state, refresh: !state.refresh };
    case 'SET_BLACKLIST_ALERT':
      return { ...state, blacklistAlert: action.payload };
    default:
      return state;
  }
};
